export const TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_MODEL =
  "Transit Courier Double Cab-in-Van";

export const TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_COLLECTION =
  "transitCourierDoubleCabInVanGetInTouch";
